module.exports = __webpack_public_path__ + "img/Trupp_ESS.a6f1a7da.svg";